var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterFenceSRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6123 3.60088L11.1015 0.248901L16.5907 9.702V25.859L11.1015 29.2156L5.6123 3.60088Z",
    fill: "#A06A38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.123047 22.507V6.34543L5.9182 3.60083L11.1014 13.0539V29.2155L0.123047 22.507Z",
    fill: "#CB8E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterFenceSRDefault);
export default __webpack_public_path__ + "static/media/winter_fence_s_r_default.6c3ac8f1ab851ffc9da72b83b1f1cd48.svg";
export { ForwardRef as ReactComponent };